import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './plugins/i18n'

import 'normalize.css'

Vue.config.productionTip = false
// document.title = '\u200E'

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
